import { createFileRoute, notFound } from "@tanstack/react-router";
import useCaseStyles from "../styles/use-cases.css?url";
import { withStylesheet } from "../lib/head";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { loadUseCases } from "../platform/use-cases";
import { UseCasesIndex } from "../platform/use-cases/use-case-pages";

/** /use-cases: Drate's templates, each a working example (Drate's host only). */
export const Route = createFileRoute("/use-cases/")({
  loader: async () => {
    const page = await loadUseCases();
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) =>
    loaderData
      ? withStylesheet(
          platformPageHead(platformShellFrom(matches), {
            pathname: "/use-cases",
            title: "Membership website examples and templates | Drate",
            description:
              "Example membership websites you can click through, from podcasts and fitness coaching to game guides. Pick the closest one and make it yours.",
            structuredData: loaderData.structuredData,
          }),
          useCaseStyles,
        )
      : {},
  component: () => <UseCasesIndex page={Route.useLoaderData()} />,
});
